// Angular Files
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RouterModule } from '@angular/router';

// Angular Material
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

// Component
import { PublicPortalFooterComponent } from './public-portal-footer.component';

// Directives
import { DirectivesModule } from '../../../directives/directives.module';

// Edit Controls
import { EditControlsModule } from '../../edit-controls/edit-controls.module';

@NgModule({
    declarations: [
        PublicPortalFooterComponent
    ],
    imports: [
        CommonModule,
        DragDropModule,
        RouterModule,
        MatButtonModule,
        MatIconModule,
        DirectivesModule,
        EditControlsModule
    ],
    exports: [
        PublicPortalFooterComponent
    ]
})
export class PublicPortalFooterModule { }
